export const version = "wallet/5.7.0";
//# sourceMappingURL=_version.js.map